import { useSelector } from 'react-redux';
import { IAppState } from 'config/redux/reducers';
import { IOrderSummaryState } from '../redux/orderSummary.reducer';

const useOrderSummary = (): IOrderSummaryState => {
  return useSelector(({ orderSummary }: IAppState) => orderSummary);
};

export default useOrderSummary;
